import React from 'react';
import Card from '@rotaryintl/harris-card';

const StandardCard = ({ fields }) => {
  const { Title, Date, Url } = fields || {};
  const cardUrl = Url?.value?.href || Url?.value || '#';
  const titleText = Title?.value || Title || '';

  return <Card isVideo={false} headline={titleText} date={Date?.value || Date} url={cardUrl} variant="outlined" />;
};

export default StandardCard;
